var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComparisonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 3.25012H9.75C8.88805 3.25012 8.0614 3.59253 7.4519 4.20202C6.84241 4.81152 6.5 5.63817 6.5 6.50012V32.5001C6.5 33.3621 6.84241 34.1887 7.4519 34.7982C8.0614 35.4077 8.88805 35.7501 9.75 35.7501H29.25C30.112 35.7501 30.9386 35.4077 31.5481 34.7982C32.1576 34.1887 32.5 33.3621 32.5 32.5001V14.6251L21.125 3.25012Z",
    stroke: "white",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1249 3.25012V14.6251H32.4999",
    stroke: "white",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonIcon);
export default __webpack_public_path__ + "static/media/comparison-icon.5c6a953ae7a41d45823e17466e261d1f.svg";
export { ForwardRef as ReactComponent };